// extracted by mini-css-extract-plugin
export default {"row":"CountdownText_row__BSzxx","mainText":"CountdownText_mainText__LfOLM","countdown":"CountdownText_countdown__C0F82","resendBtn":"CountdownText_resendBtn__dgAWN"};